import React, { useEffect, useState } from 'react'
import { useNavigate ,Link} from 'react-router-dom'
import axios from 'axios'
import Nav from './Nav'
import Footer from './footer'
import "./style/Profile.css"

export default function Profile() {
    const navigate = useNavigate()
    const [showProduct, setShowProduct] = useState({})
    const [loading, setLoading] = useState(true)
    const [hasShop, setHasShop] = useState(false) // Sirf ye add kiya
    const [stats, setStats] = useState({
        products: 0,
        orders: 0,
        rating: 0
    })

    const fetchData = async () => {
        try {
            setLoading(true)
            const res = await axios.get(`https://mkbackend-production.up.railway.app/profile`, {
                headers: {
                    token: localStorage.getItem("token")
                }
            })

            setShowProduct(res.data.user)
            
            if (res.data.user) {
                // Sirf ye check add kiya
                const userHasShop = res.data.user.shopId || 
                                   res.data.user.shop || 
                                   (res.data.user.shops && res.data.user.shops.length > 0) ||
                                   res.data.user.shopName
                
                setHasShop(!!userHasShop)
                
                setStats({
                    products: res.data.user.products?.length || 0,
                    orders: res.data.user.orders?.length || 0,
                    rating: res.data.user.rating || '⭐ 4.8'
                })
            }
        } catch (error) {
            console.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (!token) {
            navigate('/login')
            return
        }
        fetchData()
    }, [navigate])

    const handleLogout = () => {
        localStorage.clear()
        navigate('/')
    }

    // Loading state
    if (loading) {
        return (
            <div className="profile-loading">
                <div className="spinner"></div>
            </div>
        )
    }

    return (
        <div className="profile-container">
            <Nav />
            
            <div className="profile-card">
                {/* Avatar */}
                <div className="profile-avatar"></div>
                
                {/* Name */}
                <h1 className="profile-name">{showProduct.shopName || 'Your Shop'}</h1>
                
                {/* Email */}
                <p className="profile-email">{showProduct.email || 'No email'}</p>
                
                {/* Divider */}
                <div className="profile-divider"></div>
                
                {/* Stats - Commented as per your code */}
                {/* <div className="profile-stats">
                    <div className="stat-item">
                        <span className="stat-number">{stats.products}</span>
                        <span className="stat-label">Products</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-number">{stats.orders}</span>
                        <span className="stat-label">Orders</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-number">{stats.rating}</span>
                        <span className="stat-label">Rating</span>
                    </div>
                </div> */}
                
                {/* Actions */}
                <div className="profile-actions">
                    {/* <a href="/addproduct" className="add-product-btn">
                        Add Product
                    </a> */}
                    
                    {/* Sirf ye do buttons disable kiye */}
                    <Link 
                        to={hasShop ? "/allproducts" : "#"} 
                        className={`all-products-btn ${!hasShop ? 'disabled' : ''}`}
                        style={{ pointerEvents: !hasShop ? 'none' : 'auto', opacity: !hasShop ? 0.5 : 1 }}
                        title={!hasShop ? "Pehle shop create karo" : ""}
                    >
                        Edit Shop
                    </Link>
                    
                    <Link
                        to={hasShop ? "/dashboard" : "#"} 
                        className={`dashboard-link ${!hasShop ? 'disabled' : ''}`}
                        style={{ pointerEvents: !hasShop ? 'none' : 'auto', opacity: !hasShop ? 0.5 : 1 }}
                        title={!hasShop ? "Pehle shop create karo" : ""}
                    >
                        Dashboard
                    </Link>
                    
                    <button onClick={handleLogout} className="logout-btn">
                        Logout
                    </button>
                </div>
            </div>
                         <div className="ai-button-container">
                            <Link 
                                to="/ai-dashboard" 
                                className="ai-button ai-button-tooltip"
                                aria-label="Open AI Assistant"
                            >
                                <span className="ai-icon">🤖</span>
                                <span className="ai-text">AI Assistant</span>
                                <span className="ai-badge">NEW</span>
                            </Link>
                        </div>
            <div className="profile-footer">
                <Footer />
            </div>
        </div>
    )
}